import React, { useContext, useEffect, useState } from 'react';
import brand from '../../../branding';
import THEME from '../../../assets/styles/config';

import JobListContext from '../../context/jobListContext';
import AppStateContext from "../../context/appStateContext";

import getServiceCallsFunction from '../../../functions/GetServiceCallsFunction';
import useReactiveSearch from '../../../hooks/useReactiveSearch';
import useReactiveFilterForm from "../../../hooks/useReactiveFilterForm";
import useSort from '../../../hooks/sortCard';
import useDetailsResize from "../../../hooks/useDetailsResize";
import filterHelper from '../../../hooks/useFilterHelper';
import {tableData} from "../../../hooks/useFilterHelper";
import APIHelper from "../../../hooks/useAPIHelper";
import useInfiniteScroll from "../../../hooks/useInfiniteScroll";

import ExportButton from "../../../components/exportButton";
import DropDown from '../../../components/dropdown';
import FiltersRm from '../../components/filtersRm';
import JobDetail from '../../components/jobDetailReactive';
import JobsList from '../../components/Lists/cardList';
import PageHeader from '../../components/pageHeader';
import PageLayout from '../../components/pageLayout';
import SearchTab from '../../components/searchTabRm';
import ApiStatus, {CALLING,POPULATED,EMPTY,TIMEOUT} from "../../../components/apiStatus";

import HeaderImg from '../../../assets/images/headerImages/maintenance_header.png';

import {
  DropdownCtn,
  DropdownPosCtn, ExportCtn,
  JobDetailsCtn,
  JobsListCtn,
  JobsTopCtn,
  PageCtn,
  PageHeaderText,
  SearchBox,
  SearchTabCtn,
} from './index.style';
import ReactiveJob from "../../interfaces/reactiveJob";

const ReactiveMaintenance: React.FC<any> = (): React.ReactElement => {
  const {
    filtersReactive,
    filteredReactiveJobList,
    openJobDetails,
    reactiveJobList,
    updateReactiveJobList,
    clearFilters,
    clearSelectedReactiveJob,
  } = useContext(JobListContext);
  const {
    token,
    selectedCustomerId,
    siteLogo,
    setAppPageDetails,
  } = useContext(AppStateContext);

  const [ exportData, setExportData ] = useState(reactiveJobList);

  const { handleSubmit, slaTabFilters, statusTabFilters} = useReactiveFilterForm();
  const { handleSearch } = useReactiveSearch(),  { sortReactive } = useSort(), { filterDataByContract } = filterHelper(), getServiceCall = APIHelper();

  const { handleBottom, renderedData, updateRenderedData } = useInfiniteScroll(reactiveJobList, 'reactive');
  const tableHeadings = tableData['reactive'];

  const [ currentApiStatus, setCurrentApiStatus ] = useState<number>(CALLING);
  let detailsHeight = useDetailsResize(document.getElementById('details'),window.innerHeight-245);

  const callbackJobs = (data: [] | string) => {
    if(data == 'timeout') {
      setCurrentApiStatus(TIMEOUT);
      return;
    }

    if(data.length == 0) {
      setCurrentApiStatus(EMPTY);
      return;
    }

    const filteredData: ReactiveJob[] = filterDataByContract(data);

    setExportData(filteredData);

    updateReactiveJobList(filteredData);
    updateRenderedData(filteredData);

    if(slaTabFilters != '' || statusTabFilters != '') {
      handleSubmit(null);
    }

    setCurrentApiStatus(POPULATED);
  };

  useEffect(() => {
    setAppPageDetails('reactiveMaintenance');
    getServiceCall.run(getServiceCallsFunction, callbackJobs, ['', token, selectedCustomerId]);
    return () => {
      clearFilters();
      clearSelectedReactiveJob();
    }
  }, []);

  useEffect(() => {
    updateRenderedData(filteredReactiveJobList);
    if(filteredReactiveJobList.length) {
      setExportData(filteredReactiveJobList);
    } else {
      setExportData(reactiveJobList);
    }
  }, [filteredReactiveJobList, filtersReactive]);

  return (
    <PageLayout handleBottom={handleBottom} list>
      <PageHeader backgroundImg={(brand.heroImages && brand.heroImages['reactive']) || brand.heroImage || siteLogo.background_image[2]['image']['url']}>
        <PageHeaderText>Reactive Maintenance</PageHeaderText>
        <SearchBox type="text" placeholder="Search for a job name, building.." onChange={handleSearch} />
      </PageHeader>
      <PageCtn>
        <SearchTabCtn>
          <SearchTab />
        </SearchTabCtn>
        <JobsListCtn>
          <JobsTopCtn>
            <DropdownPosCtn>
              <ExportCtn>
                <ExportButton data={exportData} columns={Object.values(tableHeadings)}/>
              </ExportCtn>
              <DropdownCtn>
                <span>Sort by</span>
                <div>
                  <DropDown defaultVal={1} optionList="sort" onChange={(criteria) => sortReactive(criteria)} />
                </div>
              </DropdownCtn>
            </DropdownPosCtn>
            <FiltersRm />
          </JobsTopCtn>
          <ApiStatus status={currentApiStatus} type="ring" disable=''>
            <JobsList itemList={renderedData} page="reactiveMaintenance" type="reactive"/>
          </ApiStatus>
        </JobsListCtn>
        <JobDetailsCtn active={openJobDetails} id="details" height={detailsHeight}>
          {window.innerWidth >= THEME.layout.desktopLarge.breakpoint && <JobDetail />}
        </JobDetailsCtn>
      </PageCtn>
    </PageLayout>
  );
};

export default ReactiveMaintenance;
